"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotShiftKey = void 0;
var SpotShiftKey;
(function (SpotShiftKey) {
    SpotShiftKey["CLAIMED"] = "claimedShifts";
    SpotShiftKey["UNCLAIMED"] = "unclaimedShifts";
})(SpotShiftKey || (exports.SpotShiftKey = SpotShiftKey = {}));
